export default __webpack_public_path__ + "static/media/GradientOutdoorBottom.51ec97c0.svg";